import React from "react";

import Switch from "antd/es/switch";
import cn from "classnames";
import { defineMessages, useIntl } from "react-intl";

import { EntityType } from "@mapmycustomers/shared/enum";

import Interactive from "@app/component/map/FeaturedMap/essentials/controls/Interactive";
import { getEntityTypeDisplayName } from "@app/util/ui";

import styles from "./ShowOtherPins.module.scss";

interface Props {
  checked?: boolean;
  className?: string;
  entityType?: EntityType;
  onChange?: (value: boolean) => void;
}

const messages = defineMessages({
  title: {
    id: "map.toolbar.otherPins.title",
    defaultMessage: "Show other {type}",
    description: "Show other pins in group mode switch title",
  },
});

const ShowOtherPins: React.FC<Props> = ({
  checked,
  className,
  entityType = EntityType.PIN,
  onChange,
}) => {
  const intl = useIntl();

  return (
    <div className={cn(styles.container, className)}>
      {intl.formatMessage(messages.title, {
        type: getEntityTypeDisplayName(intl, entityType, {
          lowercase: false,
          plural: true,
        }),
      })}
      <Interactive>
        <Switch checked={checked} defaultChecked onChange={onChange} />
      </Interactive>
    </div>
  );
};

export default ShowOtherPins;
